// const ffi = require("ffi");
const path = require('path')
const iconv = require('iconv-lite');
export default class PrintCode {
    constructor() {
        this.fs = ""
        this.errorcallback = null
        this.successback = null
        const path_ = path.resolve("resources/Printer/x64/RDprinter.dll")
        this.TSPL_SetPrintParam_FLag = false
        this.User32 = ffi.Library(
            path_,
            {
                // 打开usb
                uniOpenUsb: ["int", []],
                //设置打印机内画布大小，标签纸间隙和偏移量fs：句柄，由端口打开函数获取width：画布宽度height：画布高度gap：标签纸间隙gapOffset：间隙偏移量
                TSPL_SetPageSize: ['int', ['int', 'int', 'int', 'int', 'int']],
                //设置打印时的原点坐标 fs：句柄，由端口打开函数获取x：X 坐标y：Y 坐标
                TSPL_SetReference: ['int', ['int', 'int', 'int']],
                //设置打印偏移量 fs：句柄，由端口打开函数获取 shift：偏移量，取值范围(-203,203)
                TSPL_SetPrintShift: ['int', ['int', 'int']],
                //设置国际字符集美国437
                TSPL_SetCodePage: ['int', ['int', 'int']],
                //若要开机后，第一张标签打印在正确的位置，可使用该指令fs：句柄，由端口打开函数获取
                TSPL_HOME: ['int', ['int']],
                //设置蜂鸣器声音fs：句柄，由端口打开函数获取Level：频率等级，取值范围[1,10]Interval：间隔时间，单位毫秒
                TSPL_SOUND: ['int', ['int', 'int', 'int']],
                //打印机将打印打印机信息标签 fs：句柄，由端口打开函数获取
                TSPL_SELFTEST: ['int', ['int']],
                //清空画布
                TSPL_Clear: ['int', ['int']],
                //画文字
                TSPL_DrawText: ['int', ['int', 'int', 'int', 'string', 'int', 'int', 'int', 'string']],
                //打印指令，命令打印机打印画布上的图像
                TSPL_PRINT: ['int', ['int', 'int', 'int']],
                //画二维码
                // fs：句柄，由端口打开函数获取
                // x：左上角 X 坐标
                // y：左上角 Y 坐标
                // eccLevel：容错等级，取值范围{L,M,Q,H}
                // cellWidth：宽度，取值范围[1,10]
                // mode：显示模式，取值范围{A,M}
                // rotation：旋转角度，取值范围{0,90,180,270}
                // model：版本，取值范围{M1,M2,M3,M4}
                // mask： 取值范围{S0,S1,S2,S3,S4,S5,S6,S7,S8}
                // content：二维码内容
                TSPL_DrawQRcode: ['int', ['int', 'int', 'int', 'string', 'int', 'string', 'int', 'string', 'string', 'string']],
                //画线
                TSPL_DrawLine: ['int', ['int', 'int', 'int', 'int', 'int']],
                //区域反向
                TSPL_REVERSE: ['int', ['int', 'int', 'int', 'int', 'int']],
                //设置打印机打印速度、浓度、方向
                TSPL_SetPrintParam: ['int', ['int', 'int', 'int', 'int']],
            }
        );

    }

    StringToAscii(gbkStr = '') {
        const asciiBuffer = iconv.encode(gbkStr, 'gbk');
        return asciiBuffer
    }

    setErrorCallback(callback) {
        this.errorcallback = callback
    }

    setSuccessback(callback) {
        this.successback = callback
    }

    print(username, company, url, address) {
        console.log(`传入的:${url}`)
        // const username = username //姓名
        // const company = company //公司名字
        // const url = url //二维码内容
        // const address = address //公司地址
        this.fs = this.User32.uniOpenUsb() //句柄
        console.log(this.fs, 'fs')

        if (this.fs == -1) {
            if (this.errorcallback) {
                this.errorcallback({ fs: this.fs, message: '请检查打印机的USB线是否已插在电脑上' })
            }
            return
        }

        if (!this.TSPL_SetPrintParam_FLag) {
            const TSPL_SetPrintParam = this.User32.TSPL_SetPrintParam(this.fs, 2, 4, 1)
            if (TSPL_SetPrintParam == 1) this.TSPL_SetPrintParam_FLag = true
        }

        //设置打印机宽度
        const TSPL_SetPageSize = this.User32.TSPL_SetPageSize(this.fs, 55, 35, 2, 0)
        // console.log('设置打印机宽度:', TSPL_SetPageSize)

        //设置打印时的原点坐标
        const TSPL_SetReference = this.User32.TSPL_SetReference(this.fs, 0, 30)

        //设置打印偏移量
        const TSPL_SetPrintShift = this.User32.TSPL_SetPrintShift(this.fs, 0)

        // //设置国际字符
        const TSPL_SetCodePage = this.User32.TSPL_SetCodePage(this.fs, 850)



        //第一张标签打印在正确的位置
        // const TSPL_HOME = this.User32.TSPL_HOME(this.fs)
        // console.log(TSPL_HOME)

        //蜂鸣声音
        const TSPL_SOUND = this.User32.TSPL_SOUND(this.fs, 10, 1000)

        // const TSPL_SELFTEST = this.User32.TSPL_SELFTEST(this.fs)
        // console.log(TSPL_SELFTEST)

        function splitStringByGroup(str, groupSize) {
            var result = [];
            var index = 0;

            while (index < str.length) {
                result.push(str.slice(index, index + groupSize));
                index += groupSize;
            }

            return result;
        }

        function isEnglishLetters(str) {
            return /^[a-zA-Z]+$/.test(str);
        }


        //清空画布
        const TSPL_Clear = this.User32.TSPL_Clear(this.fs)
        console.log(TSPL_Clear)


        //画线
        this.User32.TSPL_DrawLine(this.fs, 20, 10, 400, 6)
        this.User32.TSPL_DrawLine(this.fs, 20, 25, 400, 3)

        //姓名
        this.User32.TSPL_DrawText(this.fs, 40, 80, 'TSS24.BF2', 0, 1, 1, this.StringToAscii('姓名:' + username))



        let danweiY = 120
        //单位
        this.User32.TSPL_DrawText(this.fs, 40, danweiY, 'TSS24.BF2', 0, 1, 1, this.StringToAscii('单位:'))
        //单位内容
        const dawei = company
        const textArr = splitStringByGroup(dawei, 7)
        // console.log(textArr)
        for (let i = 0; i < textArr.length; i++) {
            const text = textArr[i]
            this.User32.TSPL_DrawText(this.fs, 100, danweiY, 'TSS24.BF2', 0, 1, 1, this.StringToAscii(text))
            danweiY += 28
        }

        //画二维码
        // fs：句柄，由端口打开函数获取
        // x：左上角 X 坐标
        // y：左上角 Y 坐标
        // eccLevel：容错等级，取值范围{L,M,Q,H}
        // cellWidth：宽度，取值范围[1,10]
        // mode：显示模式，取值范围{A,M}
        // rotation：旋转角度，取值范围{0,90,180,270}
        // model：版本，取值范围{M1,M2,M3,M4}
        // mask： 取值范围{S0,S1,S2,S3,S4,S5,S6,S7,S8}
        // content：二维码内容
        // console.log(this.url)
        const TSPL_DrawQRcode = this.User32.TSPL_DrawQRcode(this.fs, 285, 55, 'H', 3, "A", 0, 'M4', "S8", url)
        // console.log('二维码：', TSPL_DrawQRcode)

        //地址
        // const address = address
        const adderssArr = address.split('').reverse()
        let atx = 408;
        for (let i = 0; i < adderssArr.length; i++) {
            const at = adderssArr[i]
            this.User32.TSPL_DrawText(this.fs, atx, 230, 'TSS16.BF2', 0, 1, 1, this.StringToAscii(at))
            atx -= !isNaN(parseFloat(adderssArr[i + 1])) || isEnglishLetters(adderssArr[i + 1]) ? 8 : 16
        }

        this.User32.TSPL_DrawLine(this.fs, 20, 220, 400, 3)



        //打印指令
        const TSPL_PRINT = this.User32.TSPL_PRINT(this.fs, 1, 1)
        // console.log('打印指令：', TSPL_PRINT)
        if (TSPL_PRINT == 1 && this.successback) {
            this.successback()
        }
    }
}